import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import SelectBox from '../common/SelectBox';
import { getCycles } from '../../actions/cycleActions';
import { getGradeInstances } from '../../actions/gradeInstanceActions';
import { getBids } from '../../actions/bidActions';
import { getAgreements } from '../../actions/agreementActions';
import { toSelect } from '../../utils/helpers';

class StudentsReportFilters extends Component {
  constructor() {
    super();

    this.onChange = this.onChange.bind(this);
  }

  componentWillMount() {
    const {
      cycles,
      gradeInstances,
      getCycles,
      bids,
      agreements,
      getGradeInstances,
      getBids,
      getAgreements
    } = this.props;
    _.isEmpty(cycles) && getCycles();
    _.isEmpty(gradeInstances) && getGradeInstances();
    _.isEmpty(bids) && getBids();
    _.isEmpty(agreements) && getAgreements();
  }

  onChange(field) {
    return (value) => {
      const { filters, onChangeFilters, onChangeCurrentCycle } = this.props;
      filters[field] = value;
      if (field === 'cycle') {
        const { cycles } = this.props;
        const currentCycle = _.find(cycles, cycle => cycle.id === value);
        onChangeCurrentCycle(currentCycle);
        filters.gradeInstance = '';
      }
      onChangeFilters(filters);
    };
  }

  render() {
    const { cycles, gradeInstances, bids, agreements, currentCycle, filters } = this.props;
    const cycleInput = {
      value: filters.cycle,
      name: 'cycle',
      onChange: this.onChange('cycle')
    };
    const gradeInput = {
      value: filters.gradeInstance,
      name: 'gradeInstance',
      onChange: this.onChange('gradeInstance')
    };
    const bidInput = {
      value: filters.bid,
      name: 'bid',
      onChange: this.onChange('bid')
    };
    const agreementInput = {
      value: filters.agreement,
      name: 'agreement',
      onChange: this.onChange('agreement')
    };
    const meta = { touched: false };
    const currentGrades = gradeInstances.filter(
      grade => grade.get('cycleId') === currentCycle.id
    ).toJS();

    return (
      <div>
        <SelectBox
          placeholder="Ciclo"
          options={toSelect(cycles)}
          input={cycleInput}
          meta={meta}
        />
        <SelectBox
          placeholder="Clase"
          options={currentCycle ? toSelect(currentGrades) : []}
          input={gradeInput}
          meta={meta}
        />
        <SelectBox
          placeholder="Licitación"
          options={toSelect(bids)}
          input={bidInput}
          meta={meta}
        />
        <SelectBox
          placeholder="Convenios"
          options={toSelect(agreements)}
          input={agreementInput}
          meta={meta}
        />
      </div>
    );
  }
}

const { array, func, object } = PropTypes;

StudentsReportFilters.propTypes = {
  cycles: array.isRequired,
  gradeInstances: object.isRequired,
  bids: array.isRequired,
  agreements: array.isRequired,
  getCycles: func.isRequired,
  getGradeInstances: func.isRequired,
  getBids: func.isRequired,
  getAgreements: func.isRequired,
  filters: object.isRequired,
  currentCycle: object.isRequired,
  onChangeFilters: func.isRequired,
  onChangeCurrentCycle: func.isRequired
};

const mapState = state => ({
  cycles: state.get('cycle').toJS(),
  gradeInstances: state.getIn(['gradeInstance', 'gradeInstances']),
  bids: state.get('bid').toJS(),
  agreements: state.get('agreement').toJS()
});

const mapDispatch = dispatch => ({
  getCycles: () => dispatch(getCycles()),
  getGradeInstances: () => dispatch(getGradeInstances()),
  getBids: () => dispatch(getBids()),
  getAgreements: () => dispatch(getAgreements())
});

export default connect(mapState, mapDispatch)(StudentsReportFilters);



// WEBPACK FOOTER //
// ./src/components/report/StudentsReportFilters.js